<template>
  <v-scale-transition>
    <kits-panel
      :kits-items="statistics"
      :breadcrumbs="breadcrumbs"
    >
      <h3 class="headline grey--text text-xs-center hidden-sm-and-down">
        Statistics
      </h3>
    </kits-panel>
  </v-scale-transition>
</template>

<script>
const formTitle = 'Statistics'

export default {
  components: {
    KitsPanel: () => import(/* webpackChunkName: "kitsPanel" */ '@/components/KitsPanel'),
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Finance', disabled: false, to: '/finance/finance_kits',
        },
        {
          text: formTitle, disabled: true,
        },
      ],
      statistics: [
        {
          icon: 'mdi-cash-plus',
          path: '/finance/topup_statistics',
          title: 'Topup Statistics',
          desc: 'Topup statistics.',
        },
      ],
      clearance: '',
      code: 0,
      height: 'auto',
    }
  },
}
</script>
